import React from 'react';
import { Drawer, Button } from 'antd';
import './MobileLaunchSheet.css';

/**
 * Sheet full-screen para lançamentos no mobile/PWA.
 * Header nativo (Cancelar | título | Salvar) + body scroll + footer opcional.
 * Sem transform/--vv-offset (evita corte de topo/base no iOS).
 */
export default function MobileLaunchSheet({
  open,
  title,
  onCancel,
  onSave,
  saveLabel = 'Salvar',
  saveLoading = false,
  saveDisabled = false,
  cancelDisabled = false,
  hideSave = false,
  secondaryAction = null,
  children,
}) {
  return (
    <Drawer
      open={open}
      onClose={onCancel}
      placement="bottom"
      height="100%"
      closable={false}
      destroyOnClose
      maskClosable={!saveLoading}
      keyboard={!saveLoading}
      zIndex={1100}
      className="mobile-launch-sheet"
      rootClassName="mobile-launch-sheet-root"
      styles={{
        body: { padding: 0, display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' },
        wrapper: { height: '100%' },
      }}
    >
      <header className="mobile-launch-sheet__header">
        <Button
          type="text"
          className="mobile-launch-sheet__nav-btn"
          onClick={onCancel}
          disabled={cancelDisabled || saveLoading}
        >
          Cancelar
        </Button>
        <h2 className="mobile-launch-sheet__title">{title}</h2>
        {hideSave ? (
          <span className="mobile-launch-sheet__nav-spacer" aria-hidden="true" />
        ) : (
          <Button
            type="link"
            className="mobile-launch-sheet__nav-btn mobile-launch-sheet__nav-btn--primary"
            onClick={onSave}
            loading={saveLoading}
            disabled={saveDisabled}
          >
            {saveLabel}
          </Button>
        )}
      </header>

      <div className="mobile-launch-sheet__body">{children}</div>

      {secondaryAction ? (
        <footer className="mobile-launch-sheet__footer">{secondaryAction}</footer>
      ) : null}
    </Drawer>
  );
}
